import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { TeamMemberRow } from '../../entity';
import BoxIcon from '@shared/components/BoxIcon';

type DeleteCellProps = {
  row: TeamMemberRow;
  allRows: TeamMemberRow[];
  onDelete: (userId: string) => void;
};

const DeleteCell = ({ row, allRows, onDelete }: DeleteCellProps) => {
  const handleDelete = () => {
    const fullRow = allRows.find(r => r.userId === row.userId);
    if (!fullRow) {
      return;
    }
    onDelete(fullRow.userId);
  };

  return <BoxIcon onClick={handleDelete} icon={<DeleteOutlineIcon />} />;
};

export default DeleteCell;
